import { Box, styled } from '@mui/material';

export const StyledFullInlineMessage = styled(Box)`
  * {
    display: inline !important;
  }
`;
